import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f5417cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0f5417cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5417cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\tukuv2\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5417cc')) {
      api.createRecord('0f5417cc', component.options)
    } else {
      api.reload('0f5417cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f5417cc&scoped=true", function () {
      api.rerender('0f5417cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home2/index.vue"
export default component.exports